"use strict";
import { jsx } from "react/jsx-runtime";
const Rectangle = ({
  width,
  height,
  fill = "none",
  stroke,
  strokeWidth = 1,
  opacity,
  cursor
}) => /* @__PURE__ */ jsx(
  "rect",
  {
    x: Math.min(0, width),
    y: Math.min(0, height),
    width: Math.abs(width),
    height: Math.abs(height),
    fill,
    stroke: stroke || "none",
    strokeWidth,
    opacity,
    style: { cursor, strokeLinejoin: "round" }
  }
);
export default Rectangle;
